import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {extractDataFromModel, updateObjectWithProperty} from '@catcore/utils';
import {FeaturePort, FeaturePortConnection, FeaturePortConnectionCreateInfo} from '@catmodules/models/feature-port/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FeaturePortConnectionService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-port-connections', service);
  }

  create(item: FeaturePortConnectionCreateInfo): Observable<any> {
    const inputPort = item.port1.input ? item.port1 : item.port2;
    const outputPort = item.port1.input ? item.port2 : item.port1;

    let payload = {
      port_type1: outputPort._links.self.href,
      port_type2: inputPort._links.self.href,
      timeout: item.timeout,
      speed: item.speed,
      no_advertise_speed: item.no_advertise_speed,
    };

    payload = updateObjectWithProperty(payload, item, 'timeout');
    payload = updateObjectWithProperty(payload, item, 'speed');

    return this.queryAll()
      .post(payload)
      .map((createdModel) => {
        return createdModel;
      });
  }

  extractPort1(portConnection: FeaturePortConnection): FeaturePort {
    return extractDataFromModel<FeaturePortConnection>(portConnection, 'port_type1', '_embedded');
  }

  extractPort2(portConnection: FeaturePortConnection): FeaturePort {
    return extractDataFromModel<FeaturePortConnection>(portConnection, 'port_type2', '_embedded');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-port/services/feature-port-connection.service.ts